import { BookingEntity } from 'Models/Entities';
import { newConfirmModal } from 'Views/Components/Modal/NewConfirmModal';
import { isBeforeNow } from 'Util/_HumanWritten/GeneralHelpers/DateTimeHelpers';
import { isNullOrUndefined } from 'Util/TypeGuards';

export interface OnTransferResult {
	proceed: boolean;
	transferBoth: boolean;
}

const abort: OnTransferResult = { proceed: false, transferBoth: false };
const oneWay: OnTransferResult = { proceed: true, transferBoth: false };

export const onTransfer = async (booking: BookingEntity): Promise<OnTransferResult> => {
	const linkedLeg = booking?.returnBooking ?? booking?.returnBookingFor;

	if (!linkedLeg || booking.desynced) {
		return oneWay;
	}

	if (!linkedLeg.bookedSummary) {
		// Defensive: missing summary means we can't safely evaluate the linked leg,
		// fall back to one-way and let the backend reject if needed.
		return oneWay;
	}

	const linkedClosed = linkedLeg.bookedSummary.ferryTrip.isClosedForSpecificBookingType(booking.typeOfBooking());

	const linkedIsTransferable =
		linkedLeg.bookingStatus === 'BOOKED' &&
		!linkedLeg.checkedIn &&
		isNullOrUndefined(linkedLeg.checkInStatusId) &&
		linkedLeg.transactionStatus !== 'INVOICED' &&
		linkedLeg.transactionStatus !== 'AWAITING' &&
		!linkedClosed &&
		!isBeforeNow(linkedLeg.bookedSummary.ferryTrip.departureDateTime);

	if (!linkedIsTransferable) {
		return oneWay;
	}

	try {
		const transferBoth = await newConfirmModal(
			'We noticed you have a returning trip...',
			<div>
				<h5>Do you wish to transfer those trip details too?</h5>
			</div>,
			{
				className: 'transfer-direction-modal',
				cancelText: 'One way',
				confirmText: 'Both trips',
				resolveOnCancel: true,
				resolveOnClose: true,
				shouldCloseOnEsc: false,
				shouldCloseOnOverlayClick: false,
				showCloseButton: true,
			},
		);
		return { proceed: true, transferBoth };
	} catch {
		return abort;
	}
};
